import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {connectPopupController, createDropdown} from '@acng/frontend-discovery';
import {Watch} from '@acng/frontend-relativity';
import {guard} from '@acng/frontend-rubicon';

import {Actor} from '../../layout/context/list.js';
import {ctxFriendship} from '../context/friendships.js';
import {AmateurUpgrade, CreatorTemplateConfig} from '../../amateurPool/service/template.js';
import {FRIENDSHIP_STATE} from 'acng/model';
import {compile} from '../service/template.js';
import {list} from '../service/cache.js';
import {get} from 'acng/amateurPool/service/cache.js';

/**
 * @group DOM Attribute
 */
export const FRIEND_LIST = 'friend-list';

AttributeSetup(FRIEND_LIST, (name) => {
  const watch = Watch(`[${name}]`, ctxFriendship);
  const broadcast = Actor();

  AttributeLink(name, (element, type) => {
    ASSERT: guard(type, FRIENDSHIP_STATE, `[${name}] value`);

    watch(element, () =>
      broadcast(
        element,
        async (offset) => (offset ? [] : list(type).slice()),
        async (amateurId) => {
          const amateur = await get(amateurId);
          const link = AmateurUpgrade(amateur, CreatorTemplateConfig(amateur));

          return (target, engine) => {
            link(target, engine);

            return () => {
              createDropdown(target);
              connectPopupController(target);
            };
          };
        },
      ),
    );
  });

  return compile;
});
